import { queryClient } from "@/client";
import { DataEnrichmentEntryDto } from "@advanced-sales-technologies/backend-client/models/DataEnrichmentEntryDto";
import { useMutation } from "@tanstack/react-query";

import { listsQueryKey } from "@/hooks/api/list/useInfiniteLists";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type EnrichListBody = {
  name: string;
  items: DataEnrichmentEntryDto[];
};

export const useCreateEnrichedList = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: EnrichListBody) => apiClient.listsEnrichment.createEnrichedList({ requestBody }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [listsQueryKey] });
    },
  });

  return {
    ...mutation,
    createEnrichedList: mutation.mutate,
  };
};
